module.exports = __webpack_public_path__ + "img/Anhänger.84355fdd.svg";